package pages

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import shared.content.LegalPagesContent

@Composable
fun TermsPage() {
    val page = LegalPagesContent.termsPage
    LegalPageLayout(title = page.title) {
        P(attrs = { classes("legal-meta") }) { Text("Last updated: ${page.lastUpdated}") }
        page.sections.forEach { section ->
            LegalSectionView(section)
        }
    }
}
